import { FC } from 'react';
import { useLocation } from 'react-router';
import { NavHashLink } from 'react-router-hash-link';

import Chip from 'components/_core/Chip';
import { logEvent } from 'features/Analytics/analytics';

import * as S from './styles';

type NavItem = {
  title: string;
  urlHash: string;
};

interface Props {
  items: NavItem[];
  onNavigation: (toHash: string) => void;
}
const FormNavigationMenu: FC<Props> = ({ items, onNavigation }) => {
  const location = useLocation();

  return (
    <S.NavigationMenuContainer>
      {items.map((item) => (
        <Chip
          as={NavHashLink}
          isActive={location.hash.includes(item.urlHash)}
          key={item.urlHash}
          onClick={() => {
            logEvent({ name: 'Invoice Navigation Item Clicked' });
            onNavigation(item.urlHash);
          }}
          replace
          smooth
          to={item.urlHash}
        >
          {item.title}
        </Chip>
      ))}
    </S.NavigationMenuContainer>
  );
};

export default FormNavigationMenu;
